"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadeClearIconSize = void 0;
var _constants = require("../constants");
var _types = require("../types");
const getShadeClearIconSize = size => size === _types.ShadeSize.Medium ? _constants.SHADE_CLEAR_ICON_SIZE : _constants.SHADE_CLEAR_ICON_SMALL_SIZE;
exports.getShadeClearIconSize = getShadeClearIconSize;
